import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

/**
 * Reusable action menu component for table rows
 * 
 * @param {Array} actions - Array of action objects with structure:
 *   {
 *     label: string,
 *     icon: ReactElement,
 *     onClick: function,
 *     disabled: boolean (optional),
 *     show: boolean (optional, default true)
 *   }
 * @param {Object} row - The data row object
 */
const ActionMenu = ({ actions = [], row }) => {
  const [anchorEl, setAnchorEl] = useState(null);


  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  const handleMenuItemClick = (event, action) => {
    event.preventDefault();
    event.stopPropagation();
    handleClose();
    if (action.onClick) {
      action.onClick(row);
    }
  };

  // Filter actions based on 'show' property
  const visibleActions = actions.filter(action => action.show !== false);

  if (visibleActions.length === 0) {
    return null;
  }

  return (
    <>
      <Tooltip title="Actions">
        <IconButton size="small" onClick={handleClick}>
          <MoreVert />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        onClick={(e) => e.stopPropagation()}
      >
        {visibleActions.map((action, index) => (
          <MenuItem
            key={index}
            onClick={(e) => handleMenuItemClick(e, action)}
            disabled={action.disabled}
          >
            {action.icon && (
              <ListItemIcon>
                {action.icon}
              </ListItemIcon>
            )}
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionMenu;
